import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";

import Header from "../../Components/Header";
import JobItem from "../../Components/JobItem";
import JobsTab from "../../Components/JobsTab";
import { tabs } from "../../Components/JobsTab/const";
import SearchComponent from "../../Components/Search";
import "./index.scss";
import { useDebounce } from "../../Global/Hooks/useDebounce";
import {
  setCurrentPage,
  setSearchValue,
  setActiveJobStatus,
} from "../../Store/Slice/jobsSlice";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";
import Pagination from "../../Components/Pagination";
import {Paginate} from "../../Components/Paginate";

export default function Jobs() {
  const dispatch = useDispatch();
  const Jobs = useGetJobs();
  const [page, setPage] = useState(1);
  const { list } = useSelector((state) => state.rootReducer.jobsSlice);
  const { activeStatus } = useSelector((state) => state.rootReducer.jobsSlice);
  const [search, setSearch] = useState("");

  const handleSearch = (searchTerm) => {
    dispatch(setCurrentPage(1));
    dispatch(setSearchValue(searchTerm));
    setSearch(searchTerm);
  };

  const debouncedSearchValue = useDebounce(search, 30);

  const handlePageClick = (event) => {
    setSearch("");
    dispatch(setSearchValue(""));
    dispatch(setActiveJobStatus({
      name: 'All',
      id: 'all',
      active: true,
    }));
    dispatch(setCurrentPage(event.selected + 1));
  };

  useEffect(() => {
    dispatch(setSearchValue(debouncedSearchValue));
  }, [debouncedSearchValue]);


  useEffect(() => {
    setPage(1);
    Jobs.get();
  }, [page, activeStatus, search]);

  return (
    <>
      <Header title={"Jobs"} showFull={true} />
      <section className="jobs">
        <div className="jobs__header">
          <div className="jobs__tabs">
            <JobsTab />
          </div>
          <div className="jobs__search">
            <SearchComponent
              searchTerm={search}
              onSearch={handleSearch}
              placeholder="Search any job by names, address , PO's etc."
            />
          </div>
        </div>
        <div className="jobs__list">
          {list?.data?.length > 0 ?
            list?.data?.map((job) => <JobItem key={job?.id} job={job} />)
            : (list?.data?.length === 0 && search.length > 0) ? (
              <div className="jobs__empty">
                <img src="/assets/images/jobs-empty-search.svg" alt=""/>
                <p className="jobs__empty-text">No result found</p>
              </div>
            ) : (
              <div className="jobs__empty">
                <img src="/assets/images/jobs-empty.svg" alt=""/>
                <p className="jobs__empty-text">There are no Jobs yet.</p>
              </div>
            )
          }
        </div>
        {list?.totalPage > 1 && (
          <Paginate currentPage={page} setCurrentPage={setPage} pageCount={list?.totalPage}/>
        )}
      </section>
    </>
  );
}
